import { render } from "./AdminTrackApproved75Liquidation.vue?vue&type=template&id=c06b71a6"
import script from "./AdminTrackApproved75Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminTrackApproved75Liquidation.vue?vue&type=script&lang=js"

import "./AdminTrackApproved75Liquidation.vue?vue&type=style&index=0&id=c06b71a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__